import {API_URL} from "../config";
import axios from "../utils/axios";

class CameraSetRepository
{
    save(data) {
        return axios.post(API_URL + "/CameraSet/Save", data);
    }

    getAll(filter) {
        return axios.get(API_URL + "/CameraSet/List?", {params: filter});
    }

    getById(id) {
        return axios.get(API_URL + `/CameraSet/${id}`);
    }

    delete(id) {
        return axios.delete(API_URL + `/CameraSet/${id}`);
    }
}

export default CameraSetRepository;
